var render, staticRenderFns
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a4dc38')) {
      api.createRecord('69a4dc38', component.options)
    } else {
      api.reload('69a4dc38', component.options)
    }
    
  }
}
component.options.__file = "src/vab/components/VabCol/index.vue"
export default component.exports